import React from 'react';
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { Loader2 } from 'lucide-react';

/**
 * Small reusable confirm dialog for Connections destructive actions.
 */
const ConfirmDialog = ({
  isOpen,
  title,
  body,
  confirmLabel = 'Confirm',
  isLoading = false,
  onConfirm,
  onCancel,
}) => {
  const handleClose = () => {
    if (isLoading) return;
    onCancel?.();
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/50" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="bg-white rounded-xl border-2 border-neutral-900 shadow-lg max-w-sm w-full mx-4">
          <div className="px-6 py-4 border-b-2 border-neutral-200">
            <DialogTitle className="text-lg font-semibold text-neutral-900">
              {title}
            </DialogTitle>
          </div>

          <div className="px-6 py-4">
            <p className="text-neutral-600">{body}</p>
          </div>

          <div className="px-6 py-4 bg-neutral-50 rounded-b-xl border-t-2 border-neutral-200 flex justify-end space-x-3">
            <button
              type="button"
              onClick={handleClose}
              disabled={isLoading}
              className="px-4 py-2 text-neutral-900 hover:text-cranberry-700 transition-colors disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={isLoading}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-xl border-2 border-neutral-900 font-medium bg-cranberry-700 text-white hover:bg-cranberry-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading && (
                <Loader2 size={16} className="animate-spin" aria-hidden="true" />
              )}
              {confirmLabel}
            </button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default ConfirmDialog;
